import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'

export function useToken() {
  const { getAccessToken, isAuthenticated } = useAuth()

  const { data: token = '' } = useQuery({
    queryKey: ['accessToken'],
    queryFn: getAccessToken,
    enabled: isAuthenticated,
  })

  return token
}
